import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { NestedRouteErrorComponent } from "@/components/organisms/ErrorBoundary/NestedRouteErrorComponent";
import { plantDetailRoute } from "@/pages/PlantDetail/route";

// Cuelga de `plantDetailRoute` (contenedor transparente) y no de su layout, así
// que hereda `$plantId` sin arrastrar la cabecera ni las tabs. El PageLayout con
// sidebar lo monta cada página: al no montarlo, el wizard sale a pantalla completa.
export const plantConfigurationRoute = createRoute({
  path: "configuration",
  getParentRoute: () => plantDetailRoute,
  remountDeps: ({ params }) => params.plantId,
  component: lazyRouteComponent(async () => {
    const m = await import("./PlantConfiguration");
    return { default: m.PlantConfiguration };
  }),
  errorComponent: NestedRouteErrorComponent,
});
